import { render, staticRenderFns } from "./indexComponent.vue?vue&type=template&id=12d6b693"
import script from "./indexComponent.vue?vue&type=script&lang=js"
export * from "./indexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports